import Phaser from 'phaser';

const BG_OUTER = 0x7f1d1d;
const BG_INNER = 0xb91c1c;
const WEB_COLOR = 0xffffff;
const STROKE = 0x0a0f1f;

export function drawWeb(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));
  const webStroke = Math.max(1, Math.floor(size * 0.03));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const webR = r * 0.82;
  const spokes = 8;

  g.lineStyle(webStroke, WEB_COLOR, 1);
  for (let i = 0; i < spokes; i++) {
    const a = (i * Math.PI * 2) / spokes;
    g.beginPath();
    g.moveTo(0, 0);
    g.lineTo(webR * Math.cos(a), webR * Math.sin(a));
    g.strokePath();
  }

  for (let ring = 1; ring <= 3; ring++) {
    const ringR = (webR * ring) / 3.2;
    drawPolygonOutline(g, 0, 0, ringR, spokes, 0, WEB_COLOR, webStroke);
  }

  g.fillStyle(WEB_COLOR, 1);
  g.fillCircle(0, 0, Math.max(2, r * 0.08));
}

function drawPolygonOutline(
  g: Phaser.GameObjects.Graphics,
  cx: number,
  cy: number,
  radius: number,
  sides: number,
  rotation: number,
  color: number,
  strokeW: number,
) {
  g.lineStyle(strokeW, color, 1);
  g.beginPath();
  for (let i = 0; i <= sides; i++) {
    const a = rotation + (i * Math.PI * 2) / sides;
    const x = cx + radius * Math.cos(a);
    const y = cy + radius * Math.sin(a);
    if (i === 0) g.moveTo(x, y);
    else g.lineTo(x, y);
  }
  g.strokePath();
}
